<div class="dialog-headline">{{data.title}}</div>
<div mat-dialog-content>
  <h3 class="text-gray-800">{{data.content}}</h3>
</div>
<div mat-dialog-actions class="flex justify-center">
  <button mat-raised-button (click)="onOkClicked()" cdkFocusInitial>OK</button>
</div>
